export enum EntityType {
  Publisher = 'Publisher',
  Property = 'Property',
  User = 'User',
}
